import React, { useContext, useEffect } from "react";
import Charm from '../components/charm/charm';
import Navbar from '../components/Navbar';
import Topbar from '../components/Topbar';
const Page = () => {
  return (
    <div>
      <Topbar />
      <Navbar />
      <Charm />
    </div>
  );
};

export default Page;